import { useCallback, useRef, useState } from "react"

const useComposing = (updateValue: (valueAsNumber: string) => void) => {
  const [isComposing, setIsComposing] = useState(false)

  const selectionRef = useRef({ start: 0, end: 0 })
  const prevValueRef = useRef("")

  const onCompositionStart = useCallback((e: React.CompositionEvent<HTMLInputElement>) => {
    const node = e.currentTarget
    prevValueRef.current = node.value
    selectionRef.current.start = node.selectionStart ?? node.value.length
    selectionRef.current.end = node.selectionEnd ?? node.value.length
    setIsComposing(true)
  }, [])

  const onCompositionEnd = useCallback(
    (e: React.CompositionEvent<HTMLInputElement>) => {
      const prevValue = prevValueRef.current
      const selection = selectionRef.current

      const value = prevValue.slice(0, selection.start) + e.data + prevValue.slice(selection.end)

      updateValue(value)
      setIsComposing(false)
    },
    [updateValue]
  )

  return {
    isComposing,
    onCompositionStart,
    onCompositionEnd,
  }
}

export default useComposing
